export default __webpack_public_path__ + "static/media/cross-image.69ae4c46.svg";